import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import belongsTo from "cc-frontend/helpers/belongs-to"
import type EmberStore from "cc-frontend/services/ember-store"
import moment from "cc-frontend/utils/extended-moment"
import findDocument from "../../../../helpers/find-document"
import styles from "./sidebar.module.css"

export interface TimelineSidebarSignature {
  Args: {
    model: {
      cardStackId: string
      courseId: string
      planbookId: string
      editCourseTitleAndOrder: Function
    } & (
      | {
          isUnit: false
          dateString: string
        }
      | { isUnit: true; startDate: string; endDate: string }
    )
    order: number
    closeModal: () => void
  }
}

export default class TimelineSidebar extends Component<TimelineSidebarSignature> {
  readonly styles = styles
  @service("ember-store") store!: EmberStore
  @service modalManager

  @findDocument("args.model.cardStackId", "cardStack") cardStack
  @findDocument("args.model.courseId", "course") course
  @findDocument("args.model.planbookId", "planbook") planbook
  @belongsTo("planbook", "rotationCalendar") rotationCalendar

  get dateRangeString() {
    const model = this.args.model
    if (!model.isUnit) return ""

    const start = moment(model.startDate)
    const end = moment(model.endDate)
    const startMonth = start.format("MMM")
    const endMonth = end.format("MMM")
    if (startMonth === endMonth) {
      return start.format("MMM D") + " - " + end.format("D, YYYY")
    } else {
      return start.format("MMM D") + " - " + end.format("MMM D, YYYY")
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::Course::Timeline::Sidebar": TimelineSidebar
  }
}
